module.exports={
	"Scope": "ObservationApprovalWorkflow-List",
	"CoreEntity": "ObservationApprovalWorkflow",
	"TitleTemplate": "Observation Approval Workflows",
	"Descriptors":
	{
		"Name":
		{
			"Name": "Transition Name",
			"Hash": "ObsWfListName",
			"PictDashboard": {}
		},
		"FromStatus":
		{
			"Name": "FromStatus",
			"Hash": "ObsWfListFromStatus",
			"PictDashboard": {}
		},
		"ToStatus":
		{
			"Name": "ToStatus",
			"Hash": "ObsWfListToStatus",
			"PictDashboard": {}
		},
		"IDProject":
		{
			"Name": "Project ID",
			"Hash": "ObsWfListIDProject",
			"PictDashboard": {}
		}
	}
}
